import { AppShell } from '../../components/layout/AppShell';
import { PageLayout } from '../../components/common/PageLayout';
import { ContentCard } from '../../components/common/ContentCard';
import { PAGE_COLORS } from '../../utils/pageColors';

export const OvertimePage: React.FC = () => {
  return (
    <AppShell>
      <PageLayout
        title="Overtime"
        subtitle="Track and manage employee overtime"
        bgColor={PAGE_COLORS.calendar.bgColor}
        textColor={PAGE_COLORS.calendar.textColor}
        borderColor={PAGE_COLORS.calendar.borderColor}
        icon={<></>}
      >
        <ContentCard>
          <p className="text-gray-600">Overtime management page coming soon...</p>
        </ContentCard>
      </PageLayout>
    </AppShell>
  );
};
